import { createQueryKeys } from '@lukemorales/query-key-factory';

import type { GetInventoryParams } from '../lib/types';
import type { GetImportJobsParams } from './useGetImportJobs';

/**
 * Query keys for inventory API calls
 *
 * To invalidate ALL inventory queries, use: queries.inventory._def
 */
export const inventory = createQueryKeys('inventory', {
	// List/search queries - isolated queries for inventory list
	list: (servicesProviderId: string, params?: GetInventoryParams) => ({
		queryKey: [servicesProviderId, params],
	}),

	// Detail queries - individual inventory item queries
	detail: (id: string) => ({
		queryKey: [id],
	}),

	// Sync status queries - individual item sync status
	syncStatus: (id: string) => ({
		queryKey: ['syncStatus', id],
	}),

	// Import job queries - import job list queries
	imports: (servicesProviderId: string, params?: GetImportJobsParams) => ({
		queryKey: [servicesProviderId, params],
	}),

	// Pricing history queries - pricing history for specific items
	pricingHistory: (servicesProviderId: string, inventoryItemId: string) => ({
		queryKey: ['pricingHistory', servicesProviderId, inventoryItemId],
	}),
});
